export const PRIVACY_BANNER_COPY =
  'Before sending, consider whether this message reveals personal details you did not intend to share.';

export function PrivacyBanner() {
  return (
    <div
      role="note"
      style={{
        margin: '10px 12px 8px',
        padding: '10px 12px',
        border: '1px solid var(--line)',
        background: 'var(--paper)',
        color: 'var(--ink-soft)',
        borderRadius: 8,
        fontSize: 12,
        lineHeight: 1.45,
      }}
    >
      {PRIVACY_BANNER_COPY}
    </div>
  );
}
